import { ArticleBatchDto } from '../article-batch.dto';
import { ArticleDto } from '../article.dto';
import { PackagingDto } from '../packaging.dto';

export class ArticleSearchResponseDto {
    articleId!: number;
    name!: string;
    article!: ArticleDto;
    articleBatchId?: number;
    batch?: string;
    articleBatch?: ArticleBatchDto;
    packagingId?: number;
    packagingBatch?: string;
    packaging?: PackagingDto;
}
